import 'slick-carousel';

$('.product .product__slider').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: true,
	arrows: true,
	prevArrow: $('.product__slider-arrow--left'),
	nextArrow: $('.product__slider-arrow--right'),
	infinite: false,
	asNavFor: '.product .product__thumbs'
});

$('.product .product__thumbs').slick({
	slidesToShow: 5,
	slidesToScroll: 5,
	dots: false,
	arrows: false,
	infinite: false,
	asNavFor: '.product .product__slider',
	focusOnSelect: true,
	variableWidth: true
});
